import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { ClearingAccountLogic, InvoiceDataChangeLogic } from '@mwe/services';
import { Address, DataChangeType, Product, PushPdfInfo } from '@mwe/models';
import { BasicCardComponent } from '../../cards/basic-card/basic-card.component';
import { NgClass } from '@angular/common';
import { ButtonComponent } from '../../buttons/button/button.component';

@Component({
  selector: 'mwe-push-pdf-info-on-confirmation',
  templateUrl: './push-pdf-info-on-confirmation.component.html',
  imports: [BasicCardComponent, NgClass, ButtonComponent],
})
export class PushPdfInfoOnConfirmationComponent {
  private logic = inject(InvoiceDataChangeLogic);
  private clearingAccountLogic = inject(ClearingAccountLogic);

  @Input() info: PushPdfInfo;
  @Input() targetMode: DataChangeType;
  @Input() products: Product[];
  @Input() address: Address;
  @Output() startProcessBtnClicked = new EventEmitter<void>();

  get buttonId(): string {
    return this.cardType + 'btn';
  }

  get cardId(): string {
    return this.cardType + 'card';
  }

  private get cardType(): string {
    return this.targetMode === DataChangeType.BankAccountChangeOnly ? 'mwe-switch-to-sepa-' : 'mwe-switch-to-pdf-';
  }

  async startProcess(): Promise<void> {
    this.startProcessBtnClicked.emit();
    this.clearingAccountLogic.clearProductDetails();

    if (this.targetMode === DataChangeType.BankAccountChangeOnly) {
      this.logic.startBankAccountChangeWithoutAddressSelection(this.products, this.address);
    } else if (this.targetMode === DataChangeType.PdfInvoiceChangeOnly) {
      this.logic.startPdfInvoiceChangeWithoutAddressSelection(this.products, this.address);
    }
  }
}
